// Convert input string to array by splitting with comma and space
function covertStringToArray(value) {
  var _value$split$filter;
  return (_value$split$filter = value === null || value === void 0 ? void 0 : value.split(/[\s,]+/).filter(Boolean)) !== null && _value$split$filter !== void 0 ? _value$split$filter : [];
}

export { covertStringToArray };
//# sourceMappingURL=format.js.map
